import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class DevisFilesService {
  private base_url = `${environment.API_URL}/devis`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);
  
  constructor(private http: HttpClient) { }

  getDevisFiles(devis_id: number) {
    return this.http
      .get(`${this.base_url}/${devis_id}/files`, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  addDevisFile(body: object) {
    return this.http.post(`${this.base_url}/file`, body, { headers: this.headers });
  }

  deleteDevisFile(planning_file) {
    return this.http.delete(`${this.base_url}/file/${planning_file.id}`, { headers: this.headers });
  }

  getApiURI() {
    return environment.API_URL;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/devis-files.service.ts